// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2679":"f389a129","6117":"f389a129"}[chunkId] + ".chunk.css";
};